import React from 'react';
import {
  useGetBrokers,
  useGetTeamBrokers,
  PersonFilterInput,
} from '@converge/graphql';
import { BrokersDialog } from './shared/brokers-dialog';

interface BrokersByTeamDialogProps {
  open: boolean;
  onClose: () => void;
  teamName: string;
  teamId: string;
  entityId?: string; // Optional for backward compatibility
}

export const BrokersByTeamDialog: React.FC<BrokersByTeamDialogProps> = ({
  open,
  onClose,
  teamName,
  teamId,
  entityId,
}) => {
  // Use new team brokers query if entityId is available, otherwise fallback to old method
  const useNewQuery = !!entityId;

  // New query for team brokers following Neo4j structure
  const {
    brokers: newFetchedBrokers,
    loading: newLoading,
    error: newError,
  } = useGetTeamBrokers({
    teamId,
    enabled: useNewQuery && open && !!teamId && !!entityId,
  });

  // Fallback to old query method
  const filters: PersonFilterInput = {
    agent: true,
    team: teamId,
  };

  const {
    brokers: oldFetchedBrokers,
    loading: oldLoading,
    error: oldError,
  } = useGetBrokers({
    pageNumber: 0,
    pageSize: 100, // Get all brokers for the team
    filters,
    enabled: !useNewQuery && open && !!teamId,
  });

  // Use appropriate data based on which query is being used
  const loading = useNewQuery ? newLoading : oldLoading;
  const error = useNewQuery ? newError : oldError;

  return (
    <BrokersDialog
      open={open}
      onClose={onClose}
      title={
        teamName.toLowerCase().includes('team') ? teamName : `${teamName} Team`
      }
      testId="members-dialog"
      loading={loading}
      error={error}
      fetchedBrokers={newFetchedBrokers}
      useNewQuery={useNewQuery}
      oldFetchedBrokers={oldFetchedBrokers}
      noDataMessage="No brokers found for this team."
    />
  );
};

export default BrokersByTeamDialog;
